import React, { useState, useRef } from 'react';
import AnimatedCounter from './AnimatedCounter';
import { COUNTRY_LIST } from '../data/countries.js';

export default function UIOverlay({ stats, stage, onContribute, connected, contributed, popup, onViewNations }) {
  const selectRef = useRef(null);

  const handleChange = (e) => {
    const val = e.target.value;
    if (!val) return;
    onContribute(val);
    e.target.value = '';
  };

  return (
    <div className="rh-overlay" data-testid="radiant-overlay">

      {/* ── Top Bar ── */}
      <div className="rh-topbar" data-testid="top-bar">
        <div className="rh-logo" data-testid="logo">
          {/* Logo content if needed */}
        </div>
        
        {/* The Animated Counter Section */}
        <div className="rh-counter" data-testid="strength-counter">
          <span className="rh-counter-label">We are</span>
          <span className="rh-counter-num" data-testid="counter-number">
             {/* This now handles the "Value - 50" jump logic internally */}
             <AnimatedCounter value={stats.total} />
          </span>
          <span className="rh-counter-suffix">grains holding together</span>
        </div>
      </div>

      {/* ── Headline ── */}
      <div className="rh-headline" data-testid="headline">
        <h1>The Collective<br />Consciousness of the UAE</h1>
        <p>Our Shared Destiny</p>
      </div>

      {/* ── Connection dot ── */}
      <div className={`rh-dot ${connected ? 'rh-dot--live' : ''}`}
           data-testid="connection-dot"
           title={connected ? 'Live' : 'Reconnecting…'} />

      {/* ── Bottom Bar ── */}
      <div className="rh-bottom" data-testid="bottom-bar">
        <div className="rh-selector-wrap" data-testid="nationality-selector">
          <label className="rh-sel-label">Select Your Nationality</label>
          <div className="rh-sel-inner">
            <select
              ref={selectRef}
              className="rh-select"
              data-testid="nationality-select"
              defaultValue=""
              onChange={handleChange}
              disabled={contributed}
            >
              <option value="" disabled>
                {contributed ? 'Grain added — come back tomorrow' : 'Select Your Nationality'}
              </option>
              {COUNTRY_LIST.map(c => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
            <span className="rh-sel-arrow">▾</span>
          </div>
        </div>

        {/* Nations Panel Button */}
        <button
          className="rh-nations-btn"
          data-testid="view-nations-btn"
          onClick={onViewNations}
        >
          <span className="rh-nations-icon">◉</span>
          <span>Active Nations</span>
          {Object.keys(stats.nationalities || {}).length > 0 && (
            <span className="rh-nations-badge">
              {Object.keys(stats.nationalities).length}
            </span>
          )}
        </button>
      </div>

      {/* ── Grain Popup ── */}
      {popup && (
        <div className={`rh-popup ${popup.error ? 'rh-popup--err' : ''}`}
             data-testid="grain-popup">
          {popup.msg}
        </div>
      )}

      {/* ── Artist Credit ── */}
      <a
        className="rh-credit-btn"
        href="https://beyondverb.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        -art by Vasant Verma
      </a>
    </div>
  );
}